export * from './DeleteSetting';
export { DeleteSetting as default } from './DeleteSetting';
